
import { Edit, SimpleForm } from "react-admin";
import ListActions from "../common/ListActions";
import {
  ActionTitles,
  RESOURCES,
  RESOURCES_BASEPATH,  
} from "../Constants";
import {
  simpleForm,
} from "../Styles";
import { ReportThemeFormGrid } from "./ReportThemeFormGrid";
import { Toolbar } from "./ReportThemeToolbar";

export const ReportThemeEdit = () => {

  return (
    <Edit
      actions={
        <ListActions
          title={ActionTitles.REPORT_THEME_UPDATE}
          showViewButton={true}
          showDeleteButton={true}
          basePath={RESOURCES_BASEPATH.REPORT_THEME}
          resource={RESOURCES.REPORT_THEME}
          recordName={ActionTitles.REPORT_THEMES}
        />
      }
      mutationMode="pessimistic"
    >
      <SimpleForm
        toolbar={
          <Toolbar            
            buttonTitle={ActionTitles.UPDATE}
            basePath={RESOURCES_BASEPATH.REPORT_THEME}
            resource={RESOURCES.REPORT_THEME}
            isEdit={true}
          />
        }
        mode="onBlur"
        reValidateMode="onBlur"
        sx={simpleForm}
      >
        <ReportThemeFormGrid
          isEdit={true}
        />
      </SimpleForm>      
    </Edit>
  );
};
